import { render, staticRenderFns } from "./SliderImagensVisita.vue?vue&type=template&id=6b9a56b6&scoped=true&"
import script from "./SliderImagensVisita.vue?vue&type=script&lang=js&"
export * from "./SliderImagensVisita.vue?vue&type=script&lang=js&"
import style0 from "./SliderImagensVisita.vue?vue&type=style&index=0&id=6b9a56b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a56b6",
  null
  
)

export default component.exports